class QuickAdd {
  constructor() {
    // Quick Addコンテナと関連要素の取得
    this.quickAddContainer = document.querySelector('[data-content="quick-add"]');

    this.closeButton = this.quickAddContainer.querySelector('.js-hover-content-close');
    this.addToCartButton = this.quickAddContainer.querySelector('.js-quick-add-to-cart');
    this.addToCartButtonText = this.addToCartButton.textContent;
    this.quantityInput = this.quickAddContainer.querySelector('.js-quick-add-quantity-input');
    this.decreaseButton = this.quickAddContainer.querySelector('.js-quick-add-quantity-decrease');
    this.increaseButton = this.quickAddContainer.querySelector('.js-quick-add-quantity-increase');
    this.colorChips = this.quickAddContainer.querySelectorAll('.js-quick-add-color-chip');
    this.cartCountElement = document.getElementById('cart-count');

    // Quick Add表示用の要素
    this.hoverContentArea = document.getElementById('js-hover-content-area');
    this.quickAddContent = document.querySelector('.js-hover-content[data-content="quick-add"]');

    // 現在の商品情報を保持する変数
    this.currentVariant = null;
    this.productData = null;

    // イベントリスナーの設定
    this.setupEventListeners();
  }

  // 現在の市場に基づいて通貨をフォーマットする関数
  formatCurrency(cents) {
    const currency = window.localization?.country?.currency || { iso_code: 'JPY', symbol: '￥' };
    const locale = window.localization?.language?.iso_code || 'ja-JP';
    
    // 通貨に基づいて適切なロケールを決定
    const localeMap = {
      'USD': 'en-US',
      'EUR': 'en-GB',
      'GBP': 'en-GB',
      'CAD': 'en-CA',
      'AUD': 'en-AU',
      'JPY': 'ja-JP',
      'CNY': 'zh-CN',
      'KRW': 'ko-KR'
    };
    
    const formatLocale = localeMap[currency.iso_code] || locale;
    
    try {
      return new Intl.NumberFormat(formatLocale, {
        style: 'currency',
        currency: currency.iso_code
      }).format(cents / 100);
    } catch (error) {
      // フォールバック: 通貨記号 + 手動フォーマット
      return `${currency.symbol}${(cents / 100).toLocaleString(formatLocale)}`;
    }
  }

  setupEventListeners() {
    // Quick Addデータ準備完了イベント
    document.addEventListener('quickAddReady', this.handleQuickAddReady.bind(this));

    // 閉じるボタン
    this.closeButton.addEventListener('click', this.closeQuickAdd.bind(this));

    // カートに追加ボタン
    this.addToCartButton.addEventListener('click', this.addToCart.bind(this));

    // 数量調整ボタン
    this.decreaseButton.addEventListener('click', this.decreaseQuantity.bind(this));
    this.increaseButton.addEventListener('click', this.increaseQuantity.bind(this));

    // カラーチップ
    this.colorChips.forEach(chip => {
      chip.addEventListener('click', this.changeVariant.bind(this));
    });
  }

  // Quick Addデータ準備完了時の処理
  handleQuickAddReady(event) {
    const quickAddData = event.detail;
    this.setQuickAddData(quickAddData);
    this.showQuickAddArea();
  }

  // Quick Addエリアにデータをセット
  setQuickAddData(data) {
    const { productTitle, variantTitle, price, image, variantId, availableQuantity, productHandle, productFeaturedImage, productData, variantsData, availableVariants } = data;
  
    // 商品タイトル、バリアント、価格の設定
    this.quickAddContainer.querySelector('.js-quick-add-product-title').textContent = productTitle;
    this.quickAddContainer.querySelector('.js-quick-add-variant-title').textContent = `Color: ${variantTitle}`;
    this.quickAddContainer.querySelector('.js-quick-add-price').textContent = this.formatCurrency(price);
    
    // 商品画像の設定
    const imageElement = this.quickAddContainer.querySelector('.js-product-image');
    if (image) {
      imageElement.src = image;
      imageElement.alt = `${productTitle} - ${variantTitle}`;
      imageElement.width = 151;
      imageElement.height = 218;
      imageElement.style.objectFit = 'cover';
    }

    // 現在のバリアント情報の保存
    this.currentVariant = { 
      id: variantId, 
      availableQuantity: availableQuantity !== undefined ? availableQuantity : null 
    };
    this.productHandle = productHandle;
    this.productTitle = productTitle;
    this.productFeaturedImage = productFeaturedImage;
  
    // 「カートに追加」ボタンの更新
    this.updateAddToCartButton();
  
    // 商品データの保存
    this.productData = productData;
    this.variantsData = variantsData;
    this.availableVariants = availableVariants.filter(v => v.available && v.featured_media);
    this.productFeaturedImage = productFeaturedImage;
  
    // カラーチップの更新
    this.updateColorChips(variantId);
  
    // 数量入力フィールドのリセット
    this.quantityInput.value = '1';
    this.updateQuantityMax();
  }

  // Quick Addエリアを表示
  showQuickAddArea() {
    this.hoverContentArea.classList.add('active');
    this.quickAddContent.style.display = 'block';
    
    // カスタムカーソルのイベントリスナー追加
    document.addEventListener('mousemove', this.updateCustomCursor);
  }

  // Quick Addエリアを閉じる
  closeQuickAdd() {
    this.hoverContentArea.classList.remove('active');
    this.quickAddContent.style.display = 'none';
    
    // カスタムカーソルを非表示にし、イベントリスナーを削除
    const customCursor = document.getElementById('custom-cursor');
    if (customCursor) {
      customCursor.style.display = 'none';
    }
    document.body.classList.remove('custom-cursor-active');
    document.removeEventListener('mousemove', this.updateCustomCursor);
  
    // オーバーレイフィルターを非表示にする
    if (typeof window.hideOverlayFilter === 'function') {
      window.hideOverlayFilter();
    }
  }

  // カートに商品を追加
  async addToCart() {
    if (!this.currentVariant) return;
  
    let quantity = parseInt(this.quantityInput.value, 10);
    
    // ボタンをローディング状態にする
    this.addToCartButton.classList.add('loading');
    this.addToCartButton.disabled = true;
    this.addToCartButton.innerHTML = `
      <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
      </svg>
    `;
    
    try {
      // 現在の在庫状況を確認
      const inventoryResponse = await fetch(`/products/${this.productHandle}.js`);
      const productData = await inventoryResponse.json();
      const currentVariant = productData.variants.find(v => v.id === this.currentVariant.id);
      
      if (currentVariant && currentVariant.inventory_quantity !== null && currentVariant.inventory_quantity !== undefined) {
        // 在庫数を確認し、必要に応じて数量を調整
        quantity = Math.min(quantity, currentVariant.inventory_quantity);
      }
  
      // 数量が0の場合は1に設定（最低1つは追加する）
      quantity = Math.max(quantity, 1);
  
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: this.currentVariant.id,
            quantity: quantity
          }]
        })
      });
  
      if (!response.ok) {
        throw new Error('Failed to add item to cart');
      }
  
      await response.json();
      
      // カートの更新を待ってから次の処理を行う
      await CartUpdater.updateCartDisplay();
    } catch (error) {
      console.error('Error adding to cart:', error);
    } finally {
      // ボタンのローディング状態を解除
      this.addToCartButton.classList.remove('loading');
      this.addToCartButton.disabled = false;
      this.addToCartButton.textContent = this.addToCartButtonText;
      
      // エラーの有無に関わらず、必ずQuick Addエリアを閉じてカートエリアを表示
      this.closeQuickAdd();
      this.showCartArea();
    }
  }

  // 数量を減らす
  decreaseQuantity() {
    let currentValue = parseInt(this.quantityInput.value, 10);
    if (currentValue > 1) {
      this.quantityInput.value = currentValue - 1;
      this.updateQuantity();
    }
  }
  
  // 数量を増やす
  increaseQuantity() {
    let currentValue = parseInt(this.quantityInput.value, 10);
    this.quantityInput.value = currentValue + 1;
    this.updateQuantity();
  }

  // 数量の更新
  updateQuantity() {
    let currentQuantity = parseInt(this.quantityInput.value, 10);
    
    if (this.currentVariant && this.currentVariant.availableQuantity !== null) {
      const maxQuantity = this.currentVariant.availableQuantity;
      
      if (currentQuantity > maxQuantity) {
        currentQuantity = maxQuantity;
      }
    }
    
    this.quantityInput.value = currentQuantity;
    
    this.updateAddToCartButton();
  }

  updateQuantityMax() {
    if (this.currentVariant && this.currentVariant.availableQuantity !== null) {
      const maxQuantity = this.currentVariant.availableQuantity;
      this.quantityInput.max = maxQuantity;
    } else {
      this.quantityInput.removeAttribute('max');
    }
  }

  // バリアントの変更
  changeVariant(event) {
    const chip = event.target;
    const variantId = chip.dataset.variantId;
    
    if (!this.variantsData) {
      return;
    }
  
    const variant = this.variantsData.find(v => v.id.toString() === variantId);
    
    if (variant) {
      const variantImage = variant.featured_media ? variant.featured_media.preview_image.src : this.productFeaturedImage;
      this.updateQuickAddContent(variant, variantImage);
      this.updateColorChips(variantId);
      this.updateQuantityMax();
    }
  }

  // Quick Addコンテンツの更新
  updateQuickAddContent(variant, variantImage) {
    this.quickAddContainer.querySelector('.js-quick-add-product-title').textContent = this.productData.title;
    this.quickAddContainer.querySelector('.js-quick-add-variant-title').textContent = `Color: ${variant.title}`;
    this.quickAddContainer.querySelector('.js-quick-add-price').textContent = this.formatCurrency(variant.price);
    
    const imageElement = this.quickAddContainer.querySelector('.js-product-image');
    if (variantImage) {
      imageElement.src = variantImage;
      imageElement.alt = `${this.productData.title} - ${variant.title}`;
      imageElement.width = 151;
      imageElement.height = 218;
      imageElement.style.objectFit = 'cover';
    } else {
      console.error('Variant image not found');
    }
    
    this.currentVariant = { id: variant.id, availableQuantity: variant.inventory_quantity };
    this.updateAddToCartButton();
  }

  // カラーチップの更新
  updateColorChips(activeVariantId) {
    const colorChipsContainer = this.quickAddContainer.querySelector('.quick-add__color-chips');
    const colorChipsHTML = this.generateColorChipsHTML(activeVariantId);
    colorChipsContainer.innerHTML = colorChipsHTML;
    this.colorChips = this.quickAddContainer.querySelectorAll('.js-quick-add-color-chip');
    this.colorChips.forEach(chip => {
      chip.addEventListener('click', this.changeVariant.bind(this));
    });
  }

  // カラーチップのHTML生成
  generateColorChipsHTML(activeVariantId) {
    const colorMap = {
      'black': '#000000',
      'camel': '#A05A0C',
      'brown': '#aa7b62',
      'pale green': '#6b6d5f',
      'dark green': '#4e4f4b',
      'dark blue': '#5b656f',
      'blue': '#003399',
    };
  
    if (!this.variantsData) {
      return '';
    }
  
    const html = this.variantsData
      .filter(variant => variant.available && variant.featured_media)
      .map(variant => {
        const colorCode = colorMap[variant.title] || '#000000';
        return `
          <button
            class="js-quick-add-color-chip ${variant.id.toString() === activeVariantId.toString() ? 'active' : ''}"
            data-variant-id="${variant.id}"
            style="background-color: ${colorCode};"
            title="${variant.title}"
          ></button>
        `;
      })
      .join('');
  
    return html;
  }

  // 「カートに追加」ボタンの更新
  updateAddToCartButton() {
    this.addToCartButton.disabled = false;
    this.addToCartButton.textContent = 'Add to cart';
  }

  // カート数の更新
  updateCartCount(count) {
    if (this.cartCountElement) {
      this.cartCountElement.textContent = count;
      this.cartCountElement.classList.add('visible');
    }
  }

  // カートエリアの表示
  showCartArea() {
    const cartContent = this.hoverContentArea.querySelector('[data-content="cart"]');
    
    if (cartContent) {
      const contents = this.hoverContentArea.querySelectorAll('.js-hover-content');
      contents.forEach(content => {
        content.style.display = 'none';
      });
      
      cartContent.style.display = 'block';
      this.hoverContentArea.classList.add('active');
    }
  }

  // 画像URLの最適化
  getOptimizedImageUrl(imageUrl) {
    if (!imageUrl) {
      return '';
    }
    const baseUrl = imageUrl.split('?')[0];
    return `${baseUrl}?width=302&height=436&crop=center`;
  }

  // カスタムカーソルの更新
  updateCustomCursor(e) {
    const customCursor = document.getElementById('custom-cursor');
    if (customCursor) {
      customCursor.style.left = `${e.clientX - 25}px`;
      customCursor.style.top = `${e.clientY - 25}px`;
    }
  }
}

new QuickAdd();